import { useState, useRef, useEffect, useMemo } from "react";
import "./Bid.css";
import BidDepositInfo from "./BidDepositInfo";
import BidDepositAmountFormInfo from "./BidDepositAmountFormInfo";
import BidForm from "./BidForm";
import SuccessMessage from "./SuccessMsg";
import { formatMoney } from "@/utils/numCommas";
import {
  getUserInfoAndDetail,
  getInitiatePayment,
  isAvailableBackUpBidAmount,
  getPlaceBackupBid,
} from "@/api/bidDepositApiHold";
// import { loadStripe } from "@stripe/stripe-js";
// import { Elements } from "@stripe/react-stripe-js";
import { decrypt, decrypt2, decryptClientSecret } from "@/utils/crypto";
import FailedMsg from "./FailedMsg";
import { batch, useDispatch, useSelector } from "react-redux";
import { Elements } from "@stripe/react-stripe-js";
import {
  ShimmerButton,
  ShimmerPostDetails,
  ShimmerText,
} from "react-shimmer-effects";
import { Link, useNavigate } from "react-router";
import FaqModal from "./custom/FaqModal";
import { Button, Card, Col, Container, Form, Row } from "react-bootstrap";
import { isValidSession } from "@/api/auth";
import {
  setLoginCallLocation,
  setLoginModal,
  setLoginTab,
} from "@/redux/login/loginSlice";
// import { toast } from "react-toastify";
import LoginModal from "../common/user-credentials/LoginModal";
import {
  trackApiCall,
  trackButtonClick,
  trackPageMount,
} from "@/utils/analytics";
import { getBidDepositDetail } from "@/api/bid";
import { setBidAmount } from "@/bidFeature/bidwizardSlice";
// Initialize Stripe with  test key
// pulishablekeys

const BidDeposit = ({
  onNavigate,
  data,
  paymentFlag,
  winningBidlistingId,
  fraudlentSection,
  fraudlentAmount,
  setFraudlentAmount,
}) => {
  // console.log("biddepositinfo", data);
  const cmsData = data;
  const propertyListingId = useSelector((state) => state?.pdp);

  const [isChecked, setIsChecked] = useState(false);
  const [show, setShow] = useState(false);
  const [hideContent, setHideContent] = useState(false);
  const [hideContentTwo, setHideContentTwo] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const [userInfo, setUserInfo] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [clientID, setClientID] = useState(null);
  const [showFailMessage, setShowFailMessage] = useState(false);
  const successMsgRef = useRef(null);
  const failMsgRef = useRef(null);
  const [showFaqModal, setShowFaqModal] = useState(false);

  const [stripePromise, setStripePromise] = useState(null);
  const [stripeLoading, setStripeLoading] = useState(true);

  // const [StripeElements, setStripeElements] = useState(null);
  const [paymentReferenceNumber, setPaymentReferenceNumber] = useState(null);
  const [checkboxError, setCheckboxError] = useState(false);
  // this below is used only in case of placebackbidamount
  const [placeBackBidAmount, setPlaceBackBidAmount] = useState("");
  const [errorCardMsg, setErrorCardMsg] = useState({
    status: "ERROR",
    error_code: "",
    orderReferenceNumber: paymentReferenceNumber || "",
    errorMessage: "",
  });
  const [WinningEmail, setWinningEmail] = useState("");
  const [popUpMsg, setPopUpMsg] = useState(false);

  const globalPopup = useSelector((state) => state?.login);

  const selector = useSelector((state) => state?.bidwizardStage?.Stage);
  const selectorAmount = useSelector(
    (state) => state?.bidwizardStage?.BidAmount
  );
  // console.log(
  //   "selectorAmount",
  //   selectorAmount?.paymentGatewayPublicKey,
  //   "vvvv",
  //   selector?.validationResult?.paymentGatewayPublicKey
  // );
  // ! fetch the data of payload from save Api
  const userEmail = useSelector(
    (state) => state?.userSliceDetails?.cifResponseData?.buyer?.email
  );
  const userStoreNormal = useSelector((state) => state?.user?.user?.screenName);
  const winningBidUserEmailId = useSelector(
    (state) => state?.bidDeposit?.winningBidData
  );
  // console.log("winningbiduseremail", winningBidUserEmailId);

  const { bidRequest, validationResult } = selector || {};
  // console.log("h----------", selectorAmount);
  const isChargeApplicable =
    (selectorAmount?.bidDepositChargeAmount != null &&
      selectorAmount?.isBidDepositChargeApplicable === "Y") ||
    (validationResult?.bidDepositChargeAmount != null &&
      validationResult?.isBidDepositChargeApplicable === "Y");
  const isWinningChargeApplicable =
    selectorAmount?.bidDepositChargeAmount === null &&
    selectorAmount?.isBidDepositChargeApplicable === null;

  const formatedAmount = formatMoney(validationResult?.bidDepositAmount);
  // console.log("formatedAmount", formatedAmount);

  const formatedChargeAmount = formatMoney(
    validationResult?.bidDepositChargeAmount
  );
  // console.log("formatedChargeAmount", formatedChargeAmount);

  // const totalFormatedAmount = formatMoney(
  //   validationResult?.bidDepositAmount +
  //     validationResult?.bidDepositChargeAmount
  // );
  const totalFormatedAmount = isChargeApplicable
    ? formatMoney(
        validationResult?.bidDepositAmount +
          validationResult?.bidDepositChargeAmount
      )
    : formatMoney(
        validationResult?.bidDepositAmount || selectorAmount?.bidDepositAmount,
        0
      );
  // console.log("totalFormatedAmount", totalFormatedAmount);

  // const selectorAmountFormatted = formatMoney(
  //   selectorAmount?.bidDepositAmount + selectorAmount?.bidDepositChargeAmount
  // );
  const selectorAmountFormatted = isChargeApplicable
    ? formatMoney(
        selectorAmount?.bidDepositAmount +
          selectorAmount?.bidDepositChargeAmount
      ) // with decimals
    : formatMoney(selectorAmount?.bidDepositAmount, 0); // no decimals
  // console.log("vvvvvvcb --->", totalFormatedAmount);
  // console.log(
  //   "selectorAmountFormattedsaxxxxxxxx --->",
  //   selectorAmountFormatted
  // );
  // console.log("o1--------------", selectorAmountFormatted);
  // console.log("o2--------------", selectorAmount?.bidDepositAmount);
  // console.log("o3--------------", selectorAmount?.bidDepositChargeAmount);
  const displayAmount = formatMoney(
    validationResult?.bidDepositAmount || selectorAmount?.bidDepositAmount,
    0
  );
  const selectorFormatedAmount = formatMoney(
    selectorAmount?.bidDepositAmount,
    0
  );
  // console.log("o--------------", selectorFormatedAmount);
  const selectorFormatedChargeAmount = formatMoney(
    selectorAmount?.bidDepositChargeAmount
  );
  // console.log("o--------------", selectorFormatedChargeAmount);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleCheckboxChange = () => {
    const newCheckedState = !isChecked;
    setIsChecked(newCheckedState);
    setCheckboxError(!newCheckedState); // Show error if unchecked, hide if checked

    trackButtonClick({
      eventName: "bid_deposit_terms_toggle",
      eventCategory: "Bid Participation Page",
      eventSource: "On check terms and condition",
      eventParams: { checked: newCheckedState ? "checked" : "unchecked" },
      eventLabel: `${
        paymentFlag
          ? winningBidlistingId
          : `${propertyListingId?.bidCenterData?.listingId}`
      } | SRC : NewBidWizard`,
    });
  };

  useEffect(() => {
    // Only proceed if we have the payment gateway key
    if (
      !selectorAmount?.paymentGatewayPublicKey &&
      !selector?.validationResult?.paymentGatewayPublicKey
    ) {
      return;
    }

    const loadStripeAndElements = async () => {
      setStripeLoading(true);
      const dynamicKey =
        selectorAmount?.paymentGatewayPublicKey ||
        selector?.validationResult?.paymentGatewayPublicKey;
      // console.log("Dynamic key being used:", dynamicKey);

      if (!dynamicKey || typeof dynamicKey !== "string") {
        console.error("Invalid Stripe key:", dynamicKey);
        setStripeLoading(false);
        return;
      }

      try {
        const [{ loadStripe }] = await Promise.all([
          import("@stripe/stripe-js"),
          import("@stripe/react-stripe-js"),
        ]);

        const stripeInstance = await loadStripe(dynamicKey);
        setStripePromise(stripeInstance);
        setStripeLoading(false);

        trackPageMount({
          eventName: "bid_participation_page_loaded",
          eventCategory: "Bid Participation Page",
          eventSource: "Page Mount",
          eventLabel: `${
            paymentFlag
              ? winningBidlistingId
              : `${propertyListingId?.bidCenterData?.listingId}`
          } | SRC : NewBidWizard`,
        });

      } catch (error) {
        console.error("Error loading Stripe:", error);
        setStripeLoading(false);
      }
    };

    loadStripeAndElements();
  }, [
    selectorAmount?.paymentGatewayPublicKey,
    selector?.validationResult?.paymentGatewayPublicKey,
  ]);

  useEffect(() => {
    if (showMessage && successMsgRef.current) {
      successMsgRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [showMessage]);

  useEffect(() => {
    if (showFailMessage && failMsgRef.current) {
      failMsgRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [showFailMessage]);

  useEffect(() => {
    trackPageMount({
      eventName: "bid_deposit_hold",
      eventCategory: "Bid Participation Page",
      eventSource: "on page mount",
      eventLabel: `${
        paymentFlag
          ? winningBidlistingId
          : `${propertyListingId?.bidCenterData?.listingId}`
      } | SRC : NewBidWizard`,
    });

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  //******************! Fraudlent Bid Logic ************/
  // useEffect(() => {
  //   const handleFraudulentBid = async () => {
  //     const fraudulentPayload = {
  //       bidAmount: fraudlentSection ? fraudlentAmount : 102000,
  //       bidType: "PLACE_BID",
  //       buyerEmail: null,
  //       isFraudulentBid: "Y",
  //       listingId:
  //         propertyListingId?.bidCenterData?.listingId || "000070888AUCN4",
  //     };

  //     const bidDepositResponse = await getBidDepositDetail(fraudulentPayload);
  //     console.log(bidDepositResponse);
  //     dispatch(setBidAmount(bidDepositResponse?.data?.data));
  //   };

  //   handleFraudulentBid();
  // }, [fraudlentSection]);
  useEffect(() => {
    const handleFraudulentBid = async () => {
      const fraudulentPayload = {
        bidAmount: fraudlentSection ? fraudlentAmount : 102000,
        bidType: "PLACE_BID",
        buyerEmail: null,
        isFraudulentBid: "Y",
        listingId:
          propertyListingId?.bidCenterData?.listingId || "000070888AUCN4",
      };

      const bidDepositResponse = await getBidDepositDetail(fraudulentPayload);
      // console.log(bidDepositResponse);
      dispatch(setBidAmount(bidDepositResponse?.data?.data));
    };

    //  ONLY call if this is the fraudulent bid section
    if (fraudlentSection === true) {
      handleFraudulentBid();
    }
  }, [fraudlentSection]);

  const handleOpenModal = (e) => {
    e.preventDefault();
    setShowFaqModal(true);

    trackButtonClick({
      eventName: "bid_deposit_faqs_click",
      eventCategory: "Bid Participation Page",
      eventSource: "on faq click",
      eventLabel: `${
        paymentFlag
          ? winningBidlistingId
          : `${propertyListingId?.bidCenterData?.listingId}`
      } | SRC : NewBidWizard`,
    });
  };

  const handleCloseModal = () => {
    setShowFaqModal(false);
  };
  useEffect(() => {
    // Listen for when login modal closes successfully
    if (!globalPopup?.loginModal && popUpMsg) {
      // Modal was closed after being opened for session expiry
      setPopUpMsg(false);
      // Re-trigger the submit process
      setTimeout(() => {
        handleAgree();
      }, 1000);
    }
  }, [globalPopup?.loginModal, popUpMsg]);

  const handleAgree = async () => {
    if (!isChecked) {
      setCheckboxError(true); // Set error instead of showing alert
      return;
    }

    setIsLoading(true);
    setError(null);

    trackButtonClick({
      eventName: "bid_deposit_terms_agree_click",
      eventCategory: "Bid Participation Page",
      eventSource: "on terms agree button click",
      eventLabel: `${
        paymentFlag
          ? winningBidlistingId
          : `${propertyListingId?.bidCenterData?.listingId}`
      } | SRC : NewBidWizard`,
    });

    try {
      const isSessionValid = await isValidSession();
      const isValid = isSessionValid.data?.isValidSession;
      if (isValid === "Y") {
        // Use your existing getInitiatePayment method
        const paymentResponse = await getInitiatePayment({
          bidAmount: paymentFlag
            ? 0
            : fraudlentSection
            ? fraudlentAmount
            : `${propertyListingId?.bidCenterData?.startingBidAmount}`,
          buyerEmailId: paymentFlag
            ? winningBidUserEmailId?.buyerEmailId
            : selector?.validationResult?.buyerEmailId ||
              userEmail ||
              userStoreNormal,
          cryptoAlgVersion: "V3",
          isFraudulentBid: fraudlentSection ? "Y" : "N",
          listingId: paymentFlag
            ? winningBidlistingId
            : `${propertyListingId?.bidCenterData?.listingId}`,
          requestId: Date.now().toString(),
        });

        const encryptedClientSecret =
          paymentResponse?.data?.data?.secretClientId;
        const referenceNumber =
          paymentResponse?.data?.data?.paymentReferenceNumber;
        // Store payment reference number in state
        setPaymentReferenceNumber(referenceNumber);
        if (!encryptedClientSecret) {
          throw new Error("No encrypted client secret received");
        }
        // Log the encrypted string for debugging
        // console.log("Received encrypted data:", encryptedClientSecret);
        // Log the exact format received

        // console.log("Received encrypted data:", {
        //   value: encryptedClientSecret,
        //   length: encryptedClientSecret.length,
        //   containsEquals: encryptedClientSecret.includes("=="),
        // });
        // Decrypt the client secret
        const decryptedClientSecret = await decryptClientSecret(
          encryptedClientSecret
        );
        setClientID(decryptedClientSecret);
        // Log the decrypted string for verification
        // console.log("Decrypted client secret:", decryptedClientSecret);

        if (paymentResponse.status === 200) {
          trackApiCall({
            eventName: "bid_deposit_terms_agree_success",
            eventCategory: "Bid Participation Page",
            eventSource: "on terms api success",
            eventLabel: `${
              paymentFlag
                ? winningBidlistingId
                : `${propertyListingId?.bidCenterData?.listingId}`
            } | SRC : NewBidWizard`,
          });

          // Get user info after successful payment initiation
          const userResponse = await getUserInfoAndDetail();
          // console.log("user info and detail", userResponse.data.data);

          if (userResponse?.data?.data) {
            setUserInfo(userResponse.data.data);
            setShow(true);
            setHideContent(true);
          }
        }
      } else {
        // toast.error("Session expired. Please login again.");
        batch(() => {
          dispatch(setLoginModal(true));
          dispatch(setLoginTab("loginTab"));
          dispatch(setLoginCallLocation("Popup"));
        });
        setPopUpMsg(true);
      }
    } catch (error) {
      console.error("Error in handleAgree:", error);
      alert("Failed to process your request. Please try again.");
      setError(
        error.message || "Failed to process your request. Please try again."
      );
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getPlaceBackupBid(propertyListingId?.bidCenterData?.listingId, 0).then(
      (res) => {
        setPlaceBackBidAmount(res?.data?.data?.formattedMinBackUpBidLimit);
      }
    );
  }, [bidRequest?.bidType, propertyListingId?.bidCenterData?.listingId]);
  return (
    <>
      <>
        {globalPopup?.loginModal && <LoginModal popUpMsg={popUpMsg} />}

        {stripeLoading || !stripePromise ? (
          <>
            <ShimmerPostDetails card cta variant="SIMPLE" />
            <ShimmerPostDetails card cta variant="EDITOR" />
          </>
        ) : (
          <Elements stripe={stripePromise}>
            <div style={{ display: hideContent ? "none" : "block" }}>
              <BidDepositInfo data={cmsData} />

              <Container fluid className="px-0 mt-4">
                <Row>
                  <Col xs={12}>
                    <Card className="bid-deposit-card p-3">
                      <Card.Body>
                        <div className="mb-4 bid-deposit-title-info">
                          Bid Deposit
                        </div>
                        {bidRequest?.bidType === "PLACE_BACKUP_BID" && (
                          <p className="placebackbidamount-biddeposit text-center">
                            <span>Your bid needs to be at least</span>
                            <span> {placeBackBidAmount}</span>
                          </p>
                        )}

                        <div className="BidDeposit_background p-1">
                          <Col
                            md={3}
                            className="mt-4 vertical-divider text-center"
                          >
                            <div className="bidd-total-amount">
                              Total Amount
                            </div>
                            <div className="mb-4">
                              <span className="text-success-amount">
                                $
                                {/* {totalFormatedAmount !== "0.00" &&
                                  totalFormatedAmount}
                                {selectorAmountFormatted !== "0.00" &&
                                  selectorAmountFormatted} */}
                                {paymentFlag
                                  ? selectorAmount?.bidDepositAmount?.toLocaleString()
                                  : (totalFormatedAmount !== "0.00" ||
                                      selectorAmountFormatted !== "0.00") &&
                                    (totalFormatedAmount !== "0.00"
                                      ? totalFormatedAmount
                                      : selectorAmountFormatted)}
                              </span>
                            </div>
                          </Col>

                          <Col md={8}>
                            <div className="bid-deposit-text-info">
                              Bid deposit hold of $
                              {paymentFlag
                                ? selectorAmount?.bidDepositAmount?.toLocaleString()
                                : formatedAmount === "0.00"
                                ? selectorFormatedAmount
                                : displayAmount}{" "}
                              to be placed on your credit card.
                              <br />{" "}
                              {isChargeApplicable && (
                                <>
                                  In order to verify funds, there will be a
                                  one-time,{" "}
                                  <strong>
                                    non-refundable $
                                    {formatedChargeAmount === "0.00"
                                      ? selectorFormatedChargeAmount
                                      : formatedChargeAmount}{" "}
                                    charge.
                                  </strong>
                                  For more information,
                                  <span className="">
                                    <span
                                      href="#"
                                      onClick={handleOpenModal}
                                      className=" linkkk_bid link-offset-2 link-underline-opacity-25 link-underline-opacity-100-hover text-decoration-underline"
                                    >
                                      {" "}
                                      please see our FAQs.
                                    </span>
                                  </span>
                                </>
                              )}
                            </div>
                            <FaqModal
                              show={showFaqModal}
                              handleClose={handleCloseModal}
                            />
                          </Col>
                        </div>

                        <Row className="mt-4">
                          <Col md={12}>
                            <Form.Check
                              type="checkbox"
                              id="bidDepositCheckbox"
                              checked={isChecked}
                              onChange={handleCheckboxChange}
                              label={
                                <span className="bid-deposit-checkbox-label">
                                  <span className="bid-deposit-authorization-text">
                                    I authorize the bid deposit hold{" "}
                                    {isChargeApplicable && (
                                      <>
                                        and the one time non-refundable $
                                        {(formatedChargeAmount === "0.00"
                                          ? selectorFormatedChargeAmount
                                          : formatedChargeAmount
                                        )?.toLocaleString()}{" "}
                                        charge
                                      </>
                                    )}{" "}
                                    on my credit card.{" "}
                                  </span>
                                  <span className="bid-deposit-terms-text ">
                                    By submitting this bid deposit I understand
                                    that if I am the selected bidder and I fail
                                    to return any required contracts or send the
                                    required earnest money or sale deposit
                                    within the applicable time frame set forth
                                    in the communications or legal documents,
                                    the bid deposit hold amount will be
                                    converted to a non-refundable charge on my
                                    credit card.
                                  </span>
                                </span>
                              }
                            />
                            {checkboxError && (
                              <div className="text-danger-bidd mt-2">
                                Please accept the terms & conditions
                              </div>
                            )}
                          </Col>
                        </Row>

                        {/* <Button
                          variant="primary"
                          className="agree_button_bid m-3"
                          onClick={handleAgree}
                          disabled={isLoading}
                        >
                          {isLoading ? "Processing..." : "Agree"}
                        </Button> */}
                        <Button
                          variant="primary"
                          className="agree_button_bid m-3"
                          onClick={handleAgree}
                          disabled={isLoading}
                        >
                          {isLoading ? (
                            <span>
                              <span className="spinner-border spinner-border-sm me-2" />
                              Processing...
                            </span>
                          ) : (
                            "Agree"
                          )}
                        </Button>
                        {isLoading && (
                          <>
                            <ShimmerText line={5} gap={10} />
                          </>
                        )}
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              </Container>
            </div>

            {show && (
              <div style={{ display: hideContentTwo ? "none" : "block" }}>
                <BidDepositAmountFormInfo paymentFlag={paymentFlag} />
                <BidForm
                  setHideContentTwo={setHideContentTwo}
                  setShowMessage={setShowMessage}
                  userInfo={userInfo}
                  secretClientId={clientID}
                  setShowFailMessage={setShowFailMessage}
                  paymentReferenceNumber={paymentReferenceNumber}
                  formatedAmount={formatedAmount}
                  formatedChargeAmount={formatedChargeAmount}
                  errorCardMsg={errorCardMsg}
                  setErrorCardMsg={setErrorCardMsg}
                  paymentFlag={paymentFlag}
                  WinningEmail={WinningEmail}
                  setWinningEmail={setWinningEmail}
                  listingId={
                    winningBidlistingId ||
                    propertyListingId?.bidCenterData?.listingId
                  }
                />
              </div>
            )}

            {showMessage && (
              <div ref={successMsgRef}>
                <SuccessMessage
                  paymentReferenceNumber={paymentReferenceNumber}
                  showMessage={showMessage}
                  onNavigate={onNavigate}
                  paymentFlag={paymentFlag}
                  WinningEmail={WinningEmail}
                  fraudlentSection={fraudlentSection}
                  fraudlentAmount={fraudlentAmount}
                />
              </div>
            )}

            {showFailMessage && (
              <div ref={failMsgRef}>
                <FailedMsg
                  errorCardMsg={errorCardMsg}
                  paymentFlag={paymentFlag}
                  setErrorCardMsg={setErrorCardMsg}
                />
              </div>
            )}
          </Elements>
        )}
      </>
    </>
  );
};

export default BidDeposit;
